<template>
  <div class="add-funds">
    <img :src="img" alt="" class="logo" />
    <h2 id="title-funds">{{ $t("addFounds.title") }}</h2>

    <div class="options">
      <!-- PLatform -->
      <input class="cabinet-input" placeholder="First name" type="text" v-model="firstname" />
      <input class="cabinet-input" placeholder="Last name" type="text" v-model="lastname" />
      <input class="cabinet-input" type="email" placeholder="Email" v-model="email" />
      <CustomSelector v-model="platform" :placeholder="this.$t('addFounds.platform')" :options="platforms">
      </CustomSelector>
      <CustomSelector v-model="account" :placeholder="this.$t('addFounds.account')" :options="sources"></CustomSelector>
      <CustomSelector v-model="currency" :placeholder="this.$t('addFounds.currency')" :options="currencies">
      </CustomSelector>
      <input class="cabinet-input" type="number" :placeholder="rangeText" v-model="amount" />
      <input v-if="showbith" class="cabinet-input" type="date" v-model="dayBirth" id="dayBirth" />

      <input v-if="showmoreoptions || showaddress" class="cabinet-input" placeholder="Address" type="text"
        v-model="address" />
      <input v-if="showmoreoptions" class="cabinet-input" placeholder="Zip code" type="text" v-model="zipcode" />
      <input v-if="showmoreoptions" class="cabinet-input" placeholder="Country" type="text" v-model="country" />
      <input v-if="showmoreoptions" class="cabinet-input" placeholder="City" type="text" v-model="city" />

      <label class="input-checkbox checkBox">
        * {{ $t("addFounds.checkmark") }}
        <input type="checkbox" v-model="checkbox" />
        <span class="checkmark"></span>
      </label>

      <p class="disclaimer">
        {{ $t("addFounds.disclaimer") }}
      </p>
    </div>

    <button v-if="method === 'myfatoorah'" class="red-button" @click="transfer">
      {{ $t("addFounds.fundCreditCard") }}
    </button>

    <button v-else class="red-button" @click="transfer">
      {{ $t("addFounds.fund") }}
    </button>

    <!-- Button applepay available -->
    <div style="width: 100%; max-width: 450px;"
      v-if="(method === 'myfatoorah') && (opSystem === 'iOS' || opSystem === 'Macintosh')">
      <div class="linehr">
        <hr>
        <h1>Or</h1>
        <hr>
      </div>
      <div id="card-element"></div>
    </div>

    <button class="cabinet-back" @click="back">
      <div class="icon"></div>
      {{ $t("addFounds.back") }}
    </button>
  </div>
  <Modal v-if="redirectModal" @close="redirectModal = false" dialogStyle="login-modal">
    <template #header>
      <h3>{{ $t("addFounds.redi") }}</h3>
    </template>
    <template #body>
      <p style="width: inherit">
        {{ $t("addFounds.redirection") }} <br /><br />
        <a :href="redirecting" target="_blank">{{ redirecting }}</a>
      </p>
    </template>
  </Modal>
  <Modal v-if="showModalZotapay" dialogStyle="login-modal">
    <template #header>
      <h3>{{ $t("addFounds.redi") }}</h3>
    </template>
    <template #body>
      <div class="modal-zotapay">
        <div>
          <div class="application-form-input checkbox-input">
            <div class="application-form-input__col none-border">
              <div class="application-form-input__col__content-check">
                <label class="input-checkbox large" :class="{ invalidform: valid }">
                  <input name="purposeAccount" type="checkbox" value="hedging" @change="valid = false"
                    v-model="agree" />
                  <span class="checkmark"></span>{{ $t("addFounds.checkmark") }}
                </label>
              </div>
            </div>
          </div>
        </div>
      </div>
    </template>
  </Modal>
  <Preloader :showModal="showM"></Preloader>
</template>

<script>
import CustomSelector from "@/components/CustomSelector";

import {
  getCurrentInstance,
  onMounted,
  onUnmounted,
  ref,
  watch,
} from "@vue/runtime-core";

import store from "@/store";
import router from "@/router";
import { useRoute } from "vue-router";
import { computed } from "@vue/reactivity";
import axios from "axios";
import { CURRENCY_OPTIONS } from "../../plugins/countries";
import Modal from "@/components/Modal";
import Preloader from "@/components/Preloader";
import { i18n } from "@/plugins/i18n";

export default {
  name: "AddFundsCreditCard",
  components: {
    CustomSelector,
    Modal,
    Preloader,
  },
  setup() {
    let status_user = ref("");
    let firstname = ref("");
    let lastname = ref("");
    let email = ref(null);
    let dayBirth = ref("");
    let address = ref("");
    let zipcode = ref("");
    let city = ref("");
    let country = ref("");
    let rangeText = ref("");
    let showmoreoptions = ref(true);
    let showbith = ref(false);
    let showaddress = ref(false);
    let img = ref(null);
    let account = ref(null);
    let exchangeAmount = ref(null);
    let exchangeCurrency = ref(null);
    let target = ref([]);
    let sources = ref([
      {
        //value: '6056121',
        //text:'6056121'
      },
    ]);
    let currency = ref(null);
    let currencies = ref([]);
    let ranges = ref([]);
    let showM = ref(false);
    let redirecting = ref(null);
    let busy = ref(false);
    let moreOptions = ref(false);
    let redirectModal = ref(false);
    let platform = ref("");
    let accountsLive = ref([]);
    let body = ref([]);
    let showModalZotapay = ref(false);
    let agree = ref(false);
    let valid = ref(false);
    let viewCheckBox = ref(false);
    let checkbox = ref(false);
    let requiredCamp = ref([]);

    let accounts = ref([]);
    let accountsNumber = ref(null);

    let platforms = ref([
      {
        value: "mt4",
        text: "MetaTrader 4",
      },
      {
        value: 'mt5',
        text: 'MetaTrader 5'
      }
    ]);

    let amount = ref(100);
    let method = ref("");
    let opSystem = ref("");
    let rangeMin = ref(0)
    let rangeMax = ref(0)
    let token = ref(null);
    let cardBrand = ref(null);
    let myfatoorahSession = ref(null);
    let botonActive = ref(false);
    let initSession = ref(false);

    const internalInstance = getCurrentInstance();
    const emitter = internalInstance.appContext.config.globalProperties.emitter;

    const route = useRoute();

    onMounted(() => {
      //detect navigator
      const userAgent = navigator.userAgent || navigator.vendor || window.opera;

      if (/android/i.test(userAgent)) {
        opSystem.value = 'Android';
      } else if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
        opSystem.value = 'iOS';
      } else if (/win/i.test(userAgent)) {
        opSystem.value = 'Windows';
      } else if (/mac/i.test(userAgent)) {
        opSystem.value = 'Macintosh';
      } else if (/linux/i.test(userAgent)) {
        opSystem.value = 'Linux';
      }


      let userData = store.state.user;
      firstname.value = userData.firstName;
      lastname.value = userData.lastName;
      email.value = userData.email;
      method.value = route.params.target;
      switch (method.value) {
        case "ecommpay":
          img.value = "/assets/images/logo_ecommpay.svg";
          showmoreoptions.value = false;
          break;
        case "ecopayZ":
          img.value = "/assets/images/logo_ecopayZ.svg";
          showmoreoptions.value = false;
          showbith.value = true;
          break;
        case "skrill":
          img.value = "/assets/images/logo_skrill.svg";
          showmoreoptions.value = true;
          break;
        case "neteller":
          img.value = "/assets/images/logo_neteller.svg";
          showmoreoptions.value = false;
          showaddress.value = true;
          break;
        case "myfatoorah":
          img.value = "/assets/images/logo_myfatoorah.svg";
          showmoreoptions.value = false;
          showaddress.value = false;
          break;
        case "bitwallet":
          img.value = "/assets/images/logo_bitwallet.svg";
          showmoreoptions.value = false;
          break;
        case "pcins":
          img.value = "/assets/images/logo_pcins.svg";
          showmoreoptions.value = false;
          break;
        case "zotapay":
          img.value = "/assets/images/logo_zotapay.svg";
          showmoreoptions.value = false;
          break;
        case "globalETrader":
          img.value = "/assets/images/logo_globaletrader.svg";
          showmoreoptions.value = false;
          break;
        case "gigadat":
          img.value = "/assets/images/logo_gigadat.svg";
          showmoreoptions.value = false;
          break;
        default:
          showmoreoptions.value = false;
          break;
      }
      let platforms_pay_storage = JSON.parse(
        localStorage.getItem("DepositMethods")
      );
      platforms_pay_storage = platforms_pay_storage.creditcard;
      let currency_platform = platforms_pay_storage[method.value].currency;
      let range_alternative = platforms_pay_storage[method.value].amount_range;
      rangeMin.value = range_alternative[0]
      rangeMax.value = range_alternative[1]
      for (var cur in currency_platform) {
        currencies.value.push({
          text: currency_platform[cur],
          value: currency_platform[cur],
        });
      }
      for (var ran in range_alternative) {
        ranges.value.push({
          text: range_alternative[ran],
          value: range_alternative[ran],
        });
      }
      rangeText.value =
        i18n.global.t("addFounds.amount") +
        " (Min. " +
        ranges.value[0].text +
        " Max. " +
        ranges.value[1].text +
        ")";

      // let platforms_pay = JSON.parse(localStorage.getItem("platforms_pay"))
      window.addEventListener("keydown", reset);
      emitter.on("userUpdated", () => {
        load();
      });
      load();
    });

    onUnmounted(() => {
      window.removeEventListener("keydown", reset);
      emitter.off("userUpdated");
      emitter.off("preferencesUpdated");
    });

    watch([currency, checkbox, amount], () => {
      requestExchangeMyfatoorah();
    });


    const requestExchangeMyfatoorah = () => {
      if (currency.value !== null && amount.value !== '' && checkbox.value !== false && (opSystem.value === 'iOS' || opSystem.value === 'Macintosh')) {
        //amount valid
        if (amount.value < rangeMin.value || amount.value > rangeMax.value) {
          emitter.emit("showDialog", `Amount not valid (Min. ${rangeMin.value} - Max. ${rangeMax.value})`);
        } else {
          //preloader
          showM.value = true;
          //exchange request
          const _body = {
            amount: amount.value,
            currency: currency.value
          };

          const _url = process.env.VUE_APP_CABINET_V2_API_HOST_PAYMENTS + "/payment-alternative/myfatoorah-exchange";

          const _headers = {
            "Content-Type": "application/json",
            Accept: "application/json",
            Authorization: "Bearer " + store.state.token,
            'X-Api-Key': process.env.VUE_APP_X_API_KEY
          };
          //Currency exchange request
          axios({ method: "POST", url: _url, data: _body, headers: _headers })
            .then((result) => {
              // console.log(result.data.response.body);
              exchangeAmount.value = result.data.response.body.amount_base
              exchangeCurrency.value = result.data.response.body.currency_base
              showM.value = false;
              myFatoorahAP.updateAmount(exchangeAmount.value);

              if (currency.value !== null && amount.value !== '' && checkbox.value !== false && exchangeCurrency.value !== null && exchangeAmount.value !== null && initSession.value == false) {
                showM.value = false;
                requestMyfatoorah();
              }
            })
            .catch((error) => {
              showM.value = false;
              console.log(error);
            });
        }

        //preloader
        showM.value = false;
      }
    };

    const requestMyfatoorah = () => {
      //preloader
      showM.value = true;
      initSession = true
      // console.log('Formulario completado');
      //request for getting session id myfatoorah
      const payloadbody = {}
      const _url = process.env.VUE_APP_CABINET_V2_API_HOST_PAYMENTS + "/payment-alternative/myfatoorah-session"
      const _headers = {
        "Content-Type": "Application/json",
        "Accept": "Application/json",
        Authorization: "Bearer " + store.state.token,
        'X-Api-Key': process.env.VUE_APP_X_API_KEY
      };

      axios({ method: "POST", url: _url, data: payloadbody, headers: _headers }).then((result) => {
        // console.info('responseSession', result);

        const token = result.data.response.body.SessionId;
        const countryCode = result.data.response.body.CountryCode
        //preloader
        showM.value = false;

        var config = {
          sessionId: token, // Here you add the "SessionId" you receive from InitiateSession Endpoint.
          countryCode: "ARE", // Here, add your Country Code. 
          currencyCode: "AED", // Here, add your Currency Code.
          amount: exchangeAmount.value, // Add the invoice amount.
          // amount: 10, // Add the invoice amount.
          cardViewId: "card-element",
          callback: (responseCallback) => {
            console.log('callback response', responseCallback);
            payment(responseCallback)
          },
          sessionStarted: (responseSessionStarted) => {
            console.log('sessionStarted response', responseSessionStarted);
          },
          sessionCanceled: (responsesessionCanceled) => {
            console.log('sessionCanceled response', responsesessionCanceled);
          },
          style: {
            frameHeight: 51,
            button: {
              height: "35px",
              text: "Pay with", // Accepted texts ["", "Buy with", "Pay with", "Check Out with", "Continue with", "Book with", "Donate with", "Subscribe with", "Reload with", "Add Money with", "Top Up with", "Order with", "Rent with", "Support with", "Contribute with", "Tip with", "Set Up"]
              borderRadius: "8px"
            }
          }
        };

        myFatoorahAP.init(config);

        //callback payment
        function payment(response) {
          showM.value = false;

          // Here you need to pass session id to you backend here 
          var sessionId = response.sessionId;
          var cardBrand = response.cardBrand;
          console.info(sessionId);
          console.info(cardBrand);


          const _body = {
            firstname: firstname.value,
            lastname: lastname.value,
            customer_email: email.value,
            amount: amount.value,
            trading_account: account.value,
            currency: currency.value,
            platform: platform.value,
            tradeViewpolicy: true,
            sessionId: response.sessionId,
            cardBrand: response.cardBrand
          };

          console.log(_body);

          busy.value = true;

          const _url = process.env.VUE_APP_CABINET_V2_API_HOST_PAYMENTS + "/payment-alternative/myfatoorah";
          const _headers = {
            "Content-Type": "application/json",
            Accept: "application/json",
            Authorization: "Bearer " + store.state.token,
            'X-Api-Key': process.env.VUE_APP_X_API_KEY
          };

          axios({ method: "POST", url: _url, data: _body, headers: _headers })
            .then((result) => {
              busy.value = false;
              account.value = null;
              currency.value = null;
              amount.value = 100;
              checkbox.value = false;
              console.log(JSON.parse(result.data.response.body));
              const responseObject = JSON.parse(result.data.response.body);
              const paymentUrl = responseObject.payment_url;
              window.location.href = paymentUrl;
            })
            .catch((error) => {
              busy.value = false;
              emitter.emit("showDialog", "Error. Please Contact Tradeview Support");
              console.log(error);
            });
        }
      })

    };

    const load = () => {
      method.value = route.params.target;

      let userInfo;

      if (!store.state.user) {
        return;
      }

      if (method == "UPHOLD" || method == "ZOTAPAY" || method == "ECOMMPAY") {
        busy.value = true;
        var element = document.getElementById("title-funds");
        // removing everything inside the node
        while (element.firstChild) {
          element.removeChild(element.firstChild);
        }
        // appending new text node
        element.appendChild(
          document.createTextNode(i18n.global.t("credit.subTitleAdd"))
        );
      }

      if (method === "ZOTAPAY") {
        viewCheckBox.value = true;
      }
      userInfo = store.state.user;
    };

    const allow = computed(() => {
      let platformDefined = platform.value !== null && platform.value !== "";
      let emailDefined = email.value !== null;
      let targetDefined = account.value !== null;
      let currencyDefined = currency.value !== null && currency.value !== 0;
      let amountDefined =
        amount.value !== null &&
        amount.value > 0 &&
        amount.value >= 100 &&
        amount.value <= 10000;
      let checkBox = checkbox.value !== null && checkbox.value !== false;
      let validEmail = validateEmail(email.value);

      if (
        platformDefined &&
        targetDefined &&
        currencyDefined &&
        amountDefined &&
        emailDefined &&
        validEmail &&
        checkBox &&
        route.params.target !== "ZOTAPAY"
      ) {
        return false;
      } else {
        return true;
      }
    });

    const validateEmail = (email) => {
      return String(email)
        .toLowerCase()
        .match(
          /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        );
    };

    const transfer = () => {
      showM.value = true;
      console.log(
        firstname.value,
        lastname.value,
        amount.value,
        currency.value,
        platform.value,
        account.value
      );

      let method = route.params.target;

      let body = {};

      const v = validationsSend();

      if (amount.value < rangeMin.value || amount.value > rangeMax.value) {
        showM.value = false;
        emitter.emit("showDialog", `Amount not valid (Min. ${rangeMin.value} - Max. ${rangeMax.value})`);
      } else {
        if (v === 0) {
          switch (method) {
            case "ecommpay":
              body = {
                firstname: firstname.value,
                lastname: lastname.value,
                amount: amount.value,
                currency: currency.value,
                platform: platform.value,
                trading_account: account.value,
                payment_method: "card",
                customer_email: email.value,
                tradeViewpolicy: checkbox.value,
              };
              break;
            case "ecopayZ":
              method = "ecopayz";
              body = {
                firstname: firstname.value,
                lastname: lastname.value,
                amount: amount.value,
                currency: currency.value,
                platform: platform.value,
                trading_account: account.value,
                customer_email: email.value,
                date_of_birth: dayBirth.value,
                tradeViewpolicy: checkbox.value,
              };
              break;
            case "skrill":
              body = {
                firstname: firstname.value,
                lastname: lastname.value,
                amount: amount.value,
                currency: currency.value,
                platform: platform.value,
                trading_account: account.value,
                customer_email: email.value,
                zipcode: zipcode.value,
                address: address.value,
                city: city.value,
                country: country.value,
                redirect_success_url:
                  "https://dev.d4h6zo1xar6ex.amplifyapp.com/cabinet/console/accounts",
                redirect_fail_url:
                  "https://dev.d4h6zo1xar6ex.amplifyapp.com/cabinet/console/accounts",
                tradeViewpolicy: checkbox.value,
              };
              break;
            case "neteller":
              body = {
                firstname: firstname.value,
                lastname: lastname.value,
                amount: amount.value,
                currency: currency.value,
                platform: platform.value,
                trading_account: account.value,
                customer_email: email.value,
                address: address.value,
                tradeViewpolicy: checkbox.value,
              };
              break;
            case "myfatoorah":
              body = {
                firstname: firstname.value,
                lastname: lastname.value,
                amount: amount.value,
                currency: currency.value,
                platform: platform.value,
                trading_account: account.value,
                customer_email: email.value,
                tradeViewpolicy: checkbox.value,
              };
              break;
            case "bitwallet":
              body = {
                firstname: firstname.value,
                lastname: lastname.value,
                amount: amount.value,
                currency: currency.value,
                platform: platform.value,
                trading_account: account.value,
                customer_email: email.value,
                redirect_success_url:
                  "https://dev.d4h6zo1xar6ex.amplifyapp.com/cabinet/console/accounts",
                redirect_fail_url:
                  "https://dev.d4h6zo1xar6ex.amplifyapp.com/cabinet/console/accounts",
                tradeViewpolicy: checkbox.value,
              };
              break;
          }

          const _body = body;

          const _url =
            process.env.VUE_APP_CABINET_V2_API_HOST_PAYMENTS + "/payment/" + method;
          const _headers = {
            "Content-Type": "application/json",
            Accept: "application/json",
            Authorization: "Bearer " + store.state.token,
            'X-Api-Key': process.env.VUE_APP_X_API_KEY
          };

          axios({ method: "POST", url: _url, data: _body, headers: _headers })
            .then((result) => {
              account.value = null;
              currency.value = null;
              amount.value = 100;
              checkbox.value = false;
              console.log(JSON.parse(result.data.response.body));
              const responseObject = JSON.parse(result.data.response.body);
              const paymentUrl = responseObject.payment_url;
              window.location.href = paymentUrl;
              showM.value = false;
            })
            .catch((error) => {
              emitter.emit("showDialog", "Error. Please Contact Tradeview Support");
              console.log(error);
              showM.value = false;
            });
        }
      }
    };

    const validationsSend = () => {
      let method = route.params.target;
      switch (method) {
        case "ecommpay":
          requiredCamp.value = [
            firstname.value,
            lastname.value,
            platform.value,
            account.value,
            currency.value,
          ];
          break;
        case "ecopayZ":
          requiredCamp.value = [
            firstname.value,
            lastname.value,
            platform.value,
            account.value,
            currency.value,
            dayBirth.value,
          ];
          break;
        case "skrill":
          requiredCamp.value = [
            firstname.value,
            lastname.value,
            platform.value,
            account.value,
            currency.value,
            address.value,
            zipcode.value,
            country.value,
            city.value,
          ];
          break;
        case "neteller":
          requiredCamp.value = [
            firstname.value,
            lastname.value,
            platform.value,
            account.value,
            currency.value,
          ];
          break;
        case "myfatoorah":
          requiredCamp.value = [
            firstname.value,
            lastname.value,
            platform.value,
            account.value,
            currency.value,
          ];
          break;
        case "bitwallet":
          requiredCamp.value = [
            firstname.value,
            lastname.value,
            platform.value,
            account.value,
            currency.value,
          ];
          break;
      }
      let valid = "";
      let flag = 0;

      let required = requiredCamp.value;

      for (let i = 0; i < required.length; i++) {
        if (
          required[i] === undefined ||
          required[i] === null ||
          required[i] === "" ||
          required[i] === false
        ) {
          emitter.emit("showDialog", i18n.global.t("transfer.error"));
          showM.value = false;
          flag = 1;
          return false;
        } else {
          valid = true;
        }
      }

      if (
        /^([a-zA-Z0-9_\.\-])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/.test(
          email.value
        )
      ) {
        console.log("email ok");
      } else {
        emitter.emit("showDialog", i18n.global.t("transfer.erroremail"));
        return false;
      }

      /// validación campos no vacios
      if (!valid) {
        emitter.emit("showDialog", i18n.global.t("transfer.error"));
        showM.value = false;
        flag = 1;
        return false;
      } else {
        flag = 0;
      }

      //validacion del monto
      if (
        amount.value < rangeMin.value.text ||
        amount.value > rangeMax.value.text
      ) {
        emitter.emit("showDialog", i18n.global.t("transfer.errorThree"));
        showM.value = false;
        flag = 1;
        return false;
      }

      //validacion del check de politicas de Tradeview
      if (!checkbox.value) {
        emitter.emit("showDialog", i18n.global.t("transfer.errorcheck"));
        return false;
      }

      return flag;
    };

    const back = () => {
      router.go(-1);
    };

    const reset = (e) => {
      if (e.key === "Escape") {
        account.value = null;
        currency.value = null;
        amount.value = 100;
        checkbox.value = false;
      }
    };

    watch(platform, () => {
      sources.value = [];
      let platforChange = "";
      if (platform.value == "mt4") {
        platforChange = "mt4checkaccounts";
        accounts = JSON.parse(localStorage.getItem("Accountslv4"));
      }
      if (platform.value == "mt5") {
        platforChange = "mt5checkaccounts";
        accounts = JSON.parse(localStorage.getItem("Accountslv5"));
      }
      status_user.value = localStorage.getItem("activeAccount");
      if (
        status_user.value == "AT_DETAILS" ||
        status_user.value == "PENDING_VALIDATION"
      ) {
        emitter.emit("showDialog", i18n.global.t("accounts.dialogShowFive"));
      } else {
        // disabledBtn.value = true;
        // showM.value = false;
        if (accounts != null) {
          accountsNumber.value = accounts;
          accounts.forEach((row) => {
            sources.value.push({
              value: row.login,
              text: row.login,
            });
          });
          disabledBtn.value = false;
        }
      }
    });

    return {
      firstname,
      lastname,
      email,
      dayBirth,
      address,
      zipcode,
      city,
      country,
      showmoreoptions,
      showbith,
      showaddress,
      busy,
      allow,
      img,
      account,
      exchangeAmount,
      exchangeCurrency,
      target,
      currency,
      currencies,
      ranges,
      amount,
      sources,
      showM,
      back,
      reset,
      transfer,
      moreOptions,
      redirecting,
      redirectModal,
      platform,
      accountsLive,
      platforms,
      showModalZotapay,
      agree,
      valid,
      viewCheckBox,
      checkbox,
      body,
      rangeText,
      requiredCamp,
      method,
      opSystem,
      rangeMin,
      rangeMax,
      token,
      cardBrand,
      myfatoorahSession,
      botonActive,
      initSession
    };
  },
};
</script>

<style scoped></style>
